import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '../Modal';
import {
  acceptTCAction,
  fetchTCAcceptanceStatusAction,
} from '../../actions/termsAndConditionsAction';
import { getAppConfig } from '../../constants/appConfig';

const appConfig = getAppConfig();

export const TermsModal = () => {
  const dispatch = useDispatch();
  const tcAcceptanceStatus = useSelector((state) => state.tcAcceptanceStatus);
  const acceptTc = useSelector((state) => state.acceptTc);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchTCAcceptanceStatusAction(appConfig.ecCountryCode));
  }, [dispatch]);

  useEffect(() => {
    if (tcAcceptanceStatus.data?.hasAcceptedLatest === false) {
      setIsOpen(true);
    }
  }, [tcAcceptanceStatus.data?.hasAcceptedLatest]);

  useEffect(() => {
    if (acceptTc.success) {
      setIsOpen(false);
    }
  }, [acceptTc.success]);

  const termsS3Url = tcAcceptanceStatus.data?.latest?.s3Url;

  return (
    <Modal
      confirmLabel='I agree'
      heading='We have an update to our terms and conditions.'
      hideCancelButton
      inputStyle={{
        button: {
          backgroundColor: '#FAD14C',
          color: '#313131',
          marginLeft: 'auto',
        },
      }}
      isOpen={isOpen}
      onConfirm={() => {
        dispatch(acceptTCAction(appConfig.ecCountryCode));
      }}
      isLoading={acceptTc.pending}
      showCloseButton={false}
      inputProps={{
        sx: {
          zIndex: 99999, // note: makes sure this modal is always on top
        },
      }}
    >
      To continue using the Partner Portal, please review EatClub’s updated{' '}
      <a href={termsS3Url} target='_blank' rel='noopener noreferrer'>
        terms and conditions
      </a>
      .
    </Modal>
  );
};
